export default __webpack_public_path__ + "static/media/consuegra-logo.c9e4dfcd.png";